import Api from 'services/apiService';
import {
  CREATE_PARTIAL_USER,
  UPDATE_PARTIAL_USER,
  CREATE_USER,
} from 'actionTypes';

export default {
  [CREATE_PARTIAL_USER]: {
    endpoint: 'users/partial',
    apiFunc: Api.post,
  },
  [CREATE_USER]: {
    endpoint: 'users',
    apiFunc: Api.post,
  },
  [UPDATE_PARTIAL_USER]: {
    endpoint: 'profile',
    apiFunc: Api.put,
  },
};



// WEBPACK FOOTER //
// ./src/endpoints/userEndpoints.js